import React, {ChangeEvent, ChangeEventHandler, FormEvent, ReactElement, useEffect, useRef, useState} from "react";
import {useQueryParams} from "../hooks/useQueryParams";
import axios from "axios";
import {message} from "antd";
import CountDownButton from "../components/CountDownButton";
import {useIntl} from "react-intl";

export type WechatCodeLoginFormProps = {
    username: string
    changeUsername: (e: ChangeEvent<HTMLInputElement>) => void
    code: string
    changeCode: (e: ChangeEvent<HTMLInputElement>) => void
    loginLoading: boolean
    sendCode: (load: () => void, resolve: () => void, reject: () => void) => void
}

export function withWechatCodeLoginForm(WrappedComponent: React.FC<WechatCodeLoginFormProps>) {
    return (props: {show: boolean}) => {
        let intl = useIntl();
        const [username, setUsername] = useState('');
        const [code, setCode] = useState('');
        const queryParams = useQueryParams();
        const [loginLoading, setLoginLoading] = useState(false);

        const sendCode = (load: () => void, resolve: () => void, reject: () => void) => {
            if (!username) {
                resolve()
                return message.error(intl.formatMessage({id: '用户名不能为空'}))
            }
            load()
            axios.create().post(`${process.env.REACT_APP_ACCOUNT_URL}api/oauth2/wechat/sendCode.htm`, {
                mail: username
            }).then(data => {
                if (data.data.status === '0') {
                    message.success(intl.formatMessage({id: '发送成功'}));
                    resolve()
                    return;
                }
                reject()
                message.error(data.data.desc);
            });
        }

        const onLogin = (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault()
            if (!username) {
                return message.error(intl.formatMessage({id: '用户名不能为空'}))
            }
            if (!code) {
                return message.error(intl.formatMessage({id: '验证码不能为空'}))
            }
            setLoginLoading(true)
            axios.create().post(`${process.env.REACT_APP_ACCOUNT_URL}api/oauth2/wechat/codeLogin.htm`, {
                oauth2: queryParams,
                mail: username,
                code
            }).then(data => {
                setLoginLoading(false)
                if (data.data.status === '0') {
                    window.top.location.href = data.data.data;
                    return;
                }
                message.error(data.data.desc);
            });
        }
        const inputChangeHandler = (handler: (v: string) => void) => {
            return (e: ChangeEvent<HTMLInputElement>) => {
                handler(e.target.value)
            }
        }
        return <form className={'form'} onSubmit={onLogin} style={{display: props.show ? '' : 'none'}}>
            <WrappedComponent
            {...props}
            username={username}
            code={code}
            changeUsername={inputChangeHandler(setUsername)}
            changeCode={inputChangeHandler(setCode)}
            loginLoading={loginLoading}
            sendCode={sendCode}
            />
        </form>
    }
}
